export default __webpack_public_path__ + "static/media/pexels-kat-jayne-568021.a1fa960a.jpg";